module.exports = __webpack_public_path__ + "img/tab_r-on.c0bb50a5.png";